module.exports = __webpack_public_path__ + "static/label_eco_concu-cf8a124cc94fa1ade934824afb0ee1fb.png";